
//export const endpoint='http://127.0.0.1/reliable-dlp/api'
export const endpoint='https://reliablekota.com/php-api/api'
